import { TerminalIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "./cn";
import { CopyButton } from "./copy-button";

/** The CLI equivalent of an action: the command in mono with a copy button. */
export function CliCommand({
  command,
  label,
  className,
}: {
  command: string;
  /** What the command does, when the context does not say it. */
  label?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  return (
    <div
      className={cn(
        "flex min-w-0 items-start gap-2 rounded-sm border border-line bg-surface-2 py-1.5 pr-1 pl-2.5",
        className,
      )}
    >
      <TerminalIcon aria-hidden className="mt-[5px] size-4 shrink-0 text-ink-3" />
      <code className="min-w-0 flex-1 py-[3px] font-mono text-sm [overflow-wrap:anywhere] text-ink">
        {command}
      </code>
      <CopyButton value={command} label={label ?? t("ui.copyCommand")} className="shrink-0" />
    </div>
  );
}
